import { Header } from 'header'
import { useState } from 'react'
import { AppFooter, Explore as View } from 'ui-components'
import { AppProps } from '..'
import { PopularMaps } from './PopularMaps'
import { PrimaryTags } from './PrimaryTags'
import { SecondaryTags } from './SecondaryTags'
import { Search, SearchModal } from 'search-box'

const Explore = (props: AppProps) => {
  const [openSearchModal, setOpenSearchModal] = useState(false)
  return (
    <View
      openSearchModal={openSearchModal}
      slots={{
        Header,
        SearchModal: () => (
          <SearchModal onClose={() => setOpenSearchModal(false)} />
        ),
        Search: () => <Search onOpen={() => setOpenSearchModal(true)} />,
        PrimaryTags: () => (
          <PrimaryTags initialData={props.getPrimaryTagsResults} />
        ),
        SecondaryTags: () => (
          <SecondaryTags initialData={props.getSecondaryTagsResults} />
        ),
        PopularMaps: () => (
          <PopularMaps initialData={props.getPopularMapsResults} />
        ),
        Footer: AppFooter
      }}
    />
  )
}

export { Explore }
